export default "__VITE_ASSET__CklDJsa5__"